export const getters = {
  getPaymentsUIFlags($state) {
    return $state.uiFlags;
  },

  getPaymentsAccount($state) {
    return $state.paymentsAccount;
  },

  getInvoices($state) {
    return $state.invoices;
  },

  getPaymentStatus: ($state) => {
    return $state.paymentStatus;
  },
};
